import React, { useState, useEffect } from 'react';
import { UserPlus, X, Save, Slash } from 'lucide-react';
import Select from 'react-select';
import { useListasModel } from '../../../modelos/listas/modeloListas';
import { useFormOptions } from '../../../config/constants';
import useClientesModel from '../../../modelos/Clientes/modeloClientes';
import { useConfiguracion } from '../../../metodos/ConfiguracionContext';
import CreatableSelect from 'react-select/creatable';

const ModalAgregarCliente = ({ isOpen, onClose, onClienteAgregado }) => {
  const [formData, setFormData] = useState({
    nombreCliente: '',
    nombre: '',
    apellido: '',
    nombrecompletoCliente: '',
    carrera: '',
    universidad: '',
    numero: 0,
    correoElectronico: '',

    procedencia: '',
    campanaRealizada: '',
    noCalificado: false,

  });
  const [errors, setErrors] = useState({});
  const {
    procedenciaUsuarioListOptions,
  } = useFormOptions();
  // Importar las listas necesarias
  const {
    carrerasOptions,
    cargarCarreras,
    universidadesOptions,
    cargarUniversidades,
    isLoadingCarreras,
    isLoadingUniversidad,
  } = useListasModel();

  const {configuracion, loadingConfiguracion} = useConfiguracion();
  

  const {
    cargarListaCampanas,
    listCampanasOptions,
  } = useClientesModel();

  useEffect(() =>{
    cargarListaCampanas();
  },[])

  const resetForm = () => {
  setFormData({
    nombreCliente: '',
    nombre: '',
    apellido: '',
    nombrecompletoCliente: '',
    carrera: '',
    universidad: '',
    numero: 0,
    correoElectronico: '',

    procedencia: '',
    campanaRealizada: '',
    noCalificado: false,
  });
  setErrors({});
    };

  useEffect(() => {
    if (isOpen) {
      // Cargar listas cuando se abre el modal
      cargarCarreras();
      cargarUniversidades();
      console.log("universidades optiones cargadas",universidadesOptions)
    } else {
      resetForm();
    }
  }, [isOpen]);

  // useEffect para manejar la tecla Escape
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.nombreCliente.trim()) {
      newErrors.nombreCliente = 'El nombre del cliente es requerido';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  
  if (!validateForm()) {
    return;
  }

  try {
    // Preparar datos del cliente para enviar al padre
    const clienteData = {
      nombreCliente: formData.nombreCliente,
      nombrecompletoCliente: formData.nombrecompletoCliente || formData.nombreCliente,
      carrera: formData.carrera,
      universidad: formData.universidad,
      numero: formData.numero,
      correoElectronico: formData.correoElectronico,
      procedencia: formData.procedencia,
      campanaRealizada: formData.campanaRealizada,
      nombre: formData.nombre,
      apellido: formData.apellido,
      noCalificado: formData.noCalificado, 
    };

    // Notificar al componente padre con los datos
    onClienteAgregado(clienteData);
    
    // Limpiar formulario y cerrar modal
    resetForm();
    onClose();
    
    console.log('✅ Datos del cliente enviados al padre');
    
  } catch (error) {
    console.error('❌ Error al procesar datos del cliente:', error);
    setErrors({
      submit: 'Error al procesar los datos del cliente.'
    });
  }
    };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // Limpiar error del campo si existe
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  const handleProspectoClick = () => {
  setFormData(prev => ({
    ...prev,
    nombreCliente: 'PROSPECTO CLIENTE',
    nombrecompletoCliente: 'PROSPECTO CLIENTE'
  }));
  
  // Limpiar errores si existen
  if (errors.nombreCliente) {
    setErrors(prev => ({
      ...prev,
      nombreCliente: ''
    }));
  }
};

  const handleSelectChange = (selectedOption, { name }) => {
  setFormData(prev => {
    const newFormData = {
      ...prev,
      [name]: selectedOption ? selectedOption.value : ''
    };
    
    // Si cambia procedencia y no es CAMPAÑA INSTAGRAM, limpiar campanaRealizada
    if (name === 'procedencia' && selectedOption?.value !== 'CAMPAÑA INSTAGRAM') {
      newFormData.campanaRealizada = '';
    }
    
    return newFormData;
  });
  
  // Limpiar error del campo si existe
  if (errors[name]) {
    setErrors(prev => ({
      ...prev,
      [name]: ''
    }));
  }
};

  const getOptionFromValue = (options, value) => {
    if (!value || !options || options.length === 0) return null;
    return options.find(option => option.value === value) || null;
  };

  // Función para manejar clic fuera del modal
  const handleBackdropClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-md max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between rounded-t-xl">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-green-100 rounded-lg">
              <UserPlus size={20} className="text-green-600" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-900">Agregar Cliente</h2>
              <p className="text-sm text-gray-600">Información del nuevo cliente</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          {/* Error general */}
          {errors.submit && (
            <div className="p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-800 text-sm">{errors.submit}</p>
            </div>
          )}

          {/* Nombre Cliente */}
        <div>
        <div className="flex items-center justify-between mb-2">
            <label className="block text-sm font-medium text-gray-700">
            Nombre Cliente *
            </label>
            <button
            type="button"
            onClick={handleProspectoClick}
            className="px-3 py-1 bg-purple-100 text-purple-700 rounded-md hover:bg-purple-200 transition-colors text-sm font-medium"
            >
            PROSPECTO
            </button>
        </div>
        <input
            type="text"
            value={formData.nombreCliente}
            onChange={(e) => handleInputChange('nombreCliente', e.target.value)}
            className={`w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${
            errors.nombreCliente ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder="Nombre wsp del cliente"
            required
        />
        {errors.nombreCliente && (
            <p className="text-red-500 text-sm mt-1">{errors.nombreCliente}</p>
        )}
        </div>

          {/* Nombre Completo Cliente */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Nombre Completo Cliente
            </label>
            <input
              type="text"
              value={formData.nombrecompletoCliente}
              onChange={(e) => handleInputChange('nombrecompletoCliente', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Nombre completo del cliente (el que nos de)"
              required
            />
          </div>

          {/* Nombre del cliente || NO ES REQUERIDO*/} 
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Nombre (opcional)
            </label>
            <input
              type="text"
              value={formData.nombre}
              onChange={(e) => handleInputChange('nombre', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Nombre del cliente"
            />
          </div>

          {/* Apellido || NO ES REQUERIDO*/}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Apellido (opcional)
            </label>
            <input
              type="text"
              value={formData.apellido}
              onChange={(e) => handleInputChange('apellido', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Apellido del cliente"
            />
          </div>

          {/* Correo electronico || NO ES REQUERIDO*/}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Correo Electronico (opcional)
            </label>
            <input
              type="text"
              value={formData.correoElectronico}
              onChange={(e) => handleInputChange('correoElectronico', e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              placeholder="Correo electronico"
            />
          </div>

          {/* Número */}
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
                Número
            </label>
            <input
                type="number"
                value={formData.numero}
                onChange={(e) => handleInputChange('numero', parseInt(e.target.value) || 0)}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Número del cliente"
                min="0"
                required
            />
            </div>

          {/* Carrera */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Carrera
            </label>
            <CreatableSelect
              name="carrera"
              //value={getOptionFromValue(carreras, formData.carrera)}
              value={formData.carrera ? { label: formData.carrera, value: formData.carrera } : null}
              onChange={handleSelectChange}
              options={carrerasOptions}
              placeholder="Selecciona una carrera"
              isClearable
              isSearchable
              isLoading={isLoadingCarreras}
              loadingMessage={() => "Cargando carreras..."}
              noOptionsMessage={() => "No se encontraron carreras"}
              classNamePrefix="react-select"
            />
          </div>

          {/* Universidad */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Universidad
            </label>
            <CreatableSelect
              name="universidad"
              value={formData.universidad ? { label: formData.universidad, value: formData.universidad } : null}
              onChange={handleSelectChange}
              options={universidadesOptions}
              placeholder="Selecciona una universidad"
              isClearable
              isSearchable
              isLoading={isLoadingUniversidad}
              loadingMessage={() => "Cargando universidades..."}
              noOptionsMessage={() => "No se encontraron universidades"}
              classNamePrefix="react-select"
            />
          </div>

            {/* Procedencia */}
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
                Procedencia
            </label>
            <Select
                name="procedencia"
                value={getOptionFromValue(procedenciaUsuarioListOptions, formData.procedencia)}
                onChange={handleSelectChange}
                options={procedenciaUsuarioListOptions}
                placeholder="Selecciona la procedencia"
                isClearable
                isSearchable
                classNamePrefix="react-select"
                required
            />
            </div>

            {/* Campaña Realizada - Solo si procedencia es CAMPAÑA INSTAGRAM */}
            {formData.procedencia === 'CAMPAÑA INSTAGRAM' && (
            <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                Campaña Realizada
                </label>
                <CreatableSelect
                  name="campanaRealizada"
                  //value={getOptionFromValue(listCampanasOptions, formData.campanaRealizada)}
                  value={formData.campanaRealizada ? { label: formData.campanaRealizada, value: formData.campanaRealizada} : null}
                  onChange={handleSelectChange}
                  options={listCampanasOptions}
                  placeholder="Selecciona la campaña"
                  isClearable
                  isSearchable
                  classNamePrefix="react-select"
                />
            </div>
            )}

            {/* Sección de botones, aquí agregamos el checkbox */}
            <div className="flex items-center justify-between pt-4">
              <div className="flex items-center">
                <input
                  id="noCalificado"
                  type="checkbox"
                  checked={formData.noCalificado}
                  onChange={(e) => handleInputChange('noCalificado', e.target.checked)}
                  className="h-4 w-4 text-red-600 border-gray-300 rounded focus:ring-red-500"
                />
                <label htmlFor="noCalificado" className="ml-2 block text-sm font-medium text-gray-700">
                  Marcar como No Calificado
                </label>
              </div>
            </div>

          {/* Botones */}
          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-gray-100 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-200 transition-colors font-medium"
            >
              Cancelar
            </button>
            
            <button
              type="submit"
              className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors font-medium flex items-center justify-center gap-2"
            >
              <Save size={16} />
              Agregar Cliente
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ModalAgregarCliente;